// Logotipo oficial de la clínica (blanco sobre negro).
export const DentiumLogo = ({ size = "md" }) => {
  const heights = { sm: "h-7", md: "h-9", lg: "h-12" };
  return (
    <img
      src="/dentium-logo.png"
      alt="Dentium · Clínica Dental"
      className={`${heights[size] || heights.md} w-auto select-none`}
      data-testid="brand-logo"
      draggable={false}
    />
  );
};
